import React, { useState, useEffect, useCallback } from 'react';

const FullscreenModal = ({ 
    isOpen, 
    imageUrl, 
    images, 
    initialIndex = 0, 
    onClose, 
    altText = "Full size image" 
}) => {
    const [currentIndex, setCurrentIndex] = useState(initialIndex);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);

    useEffect(() => {
        setCurrentIndex(initialIndex);
    }, [initialIndex]);

    const navigateImage = (direction) => {
        if (!images || images.length <= 1) return;
        
        let newIndex = currentIndex + direction;
        if (newIndex < 0) newIndex = images.length - 1;
        if (newIndex >= images.length) newIndex = 0;
        setCurrentIndex(newIndex);
    };

    const handleKeyPress = useCallback((e) => {
        if (e.key === 'Escape') onClose();
        if (e.key === 'ArrowLeft') navigateImage(-1);
        if (e.key === 'ArrowRight') navigateImage(1);
    }, [currentIndex]); // eslint-disable-line react-hooks/exhaustive-deps

    // Touch event handlers for swipe gestures
    const handleTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (!touchStart || !touchEnd) return;
        
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > 50;
        const isRightSwipe = distance < -50;
        
        if (isLeftSwipe) {
            navigateImage(1); // Swipe left = next image
        } else if (isRightSwipe) {
            navigateImage(-1); // Swipe right = previous image
        }
        
        setTouchStart(null);
        setTouchEnd(null);
    };

    useEffect(() => {
        if (isOpen) {
            document.addEventListener('keydown', handleKeyPress);
            document.body.style.overflow = 'hidden';
        } else {
            document.removeEventListener('keydown', handleKeyPress);
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen, handleKeyPress]);

    if (!isOpen) return null;

    const displayImage = images && images.length > 0 ? images[currentIndex] : imageUrl;

    return (
        <div className="fullscreen-modal" onClick={onClose}>
            <div 
                className="fullscreen-content" 
                onClick={(e) => e.stopPropagation()}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                <button className="close-btn" onClick={onClose}>×</button>
                {images && images.length > 1 && (
                    <>
                        <button className="nav-btn nav-btn-left" onClick={() => navigateImage(-1)}>‹</button>
                        <button className="nav-btn nav-btn-right" onClick={() => navigateImage(1)}>›</button>
                    </>
                )}
                <img 
                    src={displayImage} 
                    alt={altText} 
                    className="fullscreen-img"
                    draggable={false}
                />
                {images && images.length > 1 && (
                    <div className="image-counter">
                        {currentIndex + 1} / {images.length}
                    </div>
                )}
            </div>
        </div>
    );
};

export default FullscreenModal; 